<template>
    <rkm-area
        title="Etapas clínicas"
        type="fieldset"
    >
        <rkm-form ref="Form">
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="etapasClinicas"
                        :validations="validations.etapaClinica"
                        label="Etapa clínica"
                        show-default-option
                        text-field="nome"
                        v-model="model.etapaClinicaId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click="$refs.Form.validate(add)"
                        color="primary"
                    >
                        Incluir
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            hide-filters
            :items="data.model.etapasClinicas"
            :fields="fields"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    :color="item.ativo ? 'dark' : 'success'"
                    :title="item.ativo ? 'Desativar' : 'Ativar'"
                    @click="toggleAtivo(item)"
                    small
                >
                    <rkm-icon :icon="item.ativo ? 'ban' : 'check-circle'" />
                </rkm-button>

                <rkm-button
                    :disabled="item.hasVinculos"
                    @click="handleDestroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </rkm-area>
</template>

<script>
// Mixins.
import { object } from '@/mixins'

// Enums.
import etapaClinica from '@/enums/cadastro/oci/etapaClinica'

export default {
    computed: {
        validations() {

            return {
                etapaClinica: { required: true }
            }
        },
        etapasClinicas() {

            const etapasNaoIncluidas = this.data.form.etapasClinicas
                .filter(e => !this.data.model.etapasClinicas.find(ec => ec.etapaClinicaId === e.id))

            const etapasEntrada = [
                this.enums.etapaClinica.ENTRADA,
                this.enums.etapaClinica.ENTRADA_ALTA,
            ]

            if (this.data.model.etapasClinicas.length === 0) {

                return etapasNaoIncluidas.filter(ec => etapasEntrada.includes(ec.id))
            }

            return etapasNaoIncluidas
        },
    },
    data: () => ({
        model: {
            etapaClinicaId: null,
            ativo: true,
        },
        fields: [
            { key: 'etapaClinicaNome', label: 'Etapa clínica', sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' }
        ],
        enums: { etapaClinica }
    }),
    methods: {
        add() {

            if (this.model.etapaClinicaId === this.enums.etapaClinica.ENTRADA && this.hasEtapaClinicaEntradaAltaAtiva()) {

                this.showAlert('Para incluir a etapa ENTRADA, desative a etapa ENTRADA/ALTA.', 'Atenção')

                return
            }
            else if (this.model.etapaClinicaId === this.enums.etapaClinica.ENTRADA_ALTA && this.hasEtapaClinicaEntradaAtiva()) {

                this.showAlert('Para incluir a etapa ENTRADA/ALTA, desative a etapa ENTRADA.', 'Atenção')

                return
            }

            const data = this.clone(this.model)

            data.etapaClinicaNome = this.data.form.etapasClinicas.find(ec => ec.id === data.etapaClinicaId).nome

            this.data.model.etapasClinicas.push(data)

            this.resetForm()
        },
        hasEtapaClinicaEntradaAltaAtiva() {

            return this.data.model.etapasClinicas.some(ec => ec.ativo && ec.etapaClinicaId === this.enums.etapaClinica.ENTRADA_ALTA)
        },
        hasEtapaClinicaEntradaAtiva() {

            return this.data.model.etapasClinicas.some(ec => ec.ativo && ec.etapaClinicaId === this.enums.etapaClinica.ENTRADA)
        },
        resetForm() {

            this.model.etapaClinicaId = null
            this.model.ativo = true

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        toggleAtivo(item) {

            if (!item.ativo) {

                if (item.etapaClinicaId === this.enums.etapaClinica.ENTRADA
                    && this.data.model.etapasClinicas.find(ec => ec.ativo && ec.etapaClinicaId === this.enums.etapaClinica.ENTRADA_ALTA)
                ) {

                    this.showAlert('Para ativar a etapa ENTRADA, desative a etapa ENTRADA/ALTA.', 'Atenção')

                    return
                }
                else if (item.etapaClinicaId === this.enums.etapaClinica.ENTRADA_ALTA
                    && this.data.model.etapasClinicas.find(ec => ec.ativo && ec.etapaClinicaId === this.enums.etapaClinica.ENTRADA)
                ) {

                    this.showAlert('Para ativar a etapa ENTRADA/ALTA, desative a etapa ENTRADA.', 'Atenção')

                    return
                }
            }

            item.ativo = !item.ativo
        },
        handleDestroy(etapaClinica) {

            const destroy = async () => {

                this.data.model.etapasClinicas.splice(this.data.model.etapasClinicas.indexOf(etapaClinica), 1)
            }

            this.showDeleteConfirmation('Deseja realmente excluir a etapa clínica?', destroy)
        }
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true }
    }
}
</script>